import { Api } from './Api';

const  ENPOINTS = {
    Document: 'documents',
};

const getAll = signal => {
    return Api.get(ENPOINTS.Document, signal)
}

const getById = (id, signal) => {
    return Api.get(`${ENPOINTS.Document}/${id}`, signal);
}

const create = (payload, signal) => {
    return Api.post(ENPOINTS.Document, payload, signal)
}

const update = (id, payload, signal) => {
    return Api.put(`${ENPOINTS.Document}/${id}`, payload, signal)
}
const destroy = (id, signal) => {
    return Api.erase(`${ENPOINTS.Document}/${id}`, signal)
}

export const DocumentService = {
    getAll,
    getById,
    create,
    update,
    destroy
}